import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {
  loginEndpoint: `${process.env.VUE_APP_API_URL}/api/auth/login`,
  logoutEndpoint: `${process.env.VUE_APP_API_URL}/api/auth/logout`,
  refreshEndpoint: `${process.env.VUE_APP_API_URL}/api/auth/refresh`
})
export default jwt
